import { InputForm, SubmitButton, Error, SelectForm } from "components";
import { useEffect } from "react";
import { fetchMembershipDurationByPackageId } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/action";
import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { connect } from "react-redux";
import {
  CreateMembershipPlanInput,
  CreateMembershipPlanInputError,
} from "../../../store/actionType";
import { MembershipDurationsProps } from "modules/membership_plan/commercial_membership_plan/membership_duration/store/actionType";
import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { fetchCommercialUsers } from "modules/user_management/commercial_user/user/state/action";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";

interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: CreateMembershipPlanInput;
  handleChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  error: CreateMembershipPlanInputError;
  loading: boolean;
  header: string;
  isSerachUser?: boolean;
  initialData?: Partial<CreateMembershipPlanInput>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;

const MembershipPlanForm: React.FC<Props> = ({
  onFetchMembershipDuration,
  fetchMembershipDurationByPackageId,
  onFetchPackages,
  fetchPackages,
  onFetchCommercialUsers,
  fetchCommercialUsers,
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header,
  isSerachUser,
  initialData,
}) => {
  useEffect(() => {
    if (initialData) {
      Object.entries(initialData).forEach(([key, value]) => {
        if (value) {
          handleChange({
            target: {
              name: key,
              value: value.toString(),
              type: "text",
            },
          } as React.ChangeEvent<HTMLInputElement>);
        }
      });
    }
  }, [initialData]);

  // fetch packages on mount
  useEffect(() => {
    onFetchPackages();
    if (formData.package_id) {
      onFetchMembershipDuration(formData.package_id);
    }
  }, [formData.package_id, onFetchMembershipDuration, onFetchPackages]);
  // useEffect(() => {
  //   onFetchCommercialUsers();
  // }, [onFetchCommercialUsers]);

  // const filteredUsers = formData.user_id
  //   ? fetchCommercialUsers?.commercialUsers?.filter(
  //       (user: CommercialUserProps) =>
  //         user.email.includes(formData.user_id) ||
  //         user.mobile_no.includes(formData.user_id) ||
  //         user.user_identifier.includes(formData.user_id)
  //     )
  //   : [];

  return (
    <section className="w-full flex flex-col p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold mb-4">{header}</h2>

        <div className="grid grid-cols-1 gap-3">
          <div>
            <SelectForm
              label="Select Package"
              id="package_id"
              name="package_id"
              value={formData.package_id}
              option={fetchPackages?.packages?.map((pkg: PackageProps) => (
                <option key={pkg.id.toString()} value={pkg.id.toString()}>
                  {pkg.name}
                </option>
              ))}
              onChange={(e) => {
                handleChange(e);
                onFetchMembershipDuration(e.target.value);
              }}
            />
          </div>
          <SelectForm
            label="Select Membership Duration"
            id="membership_duration_id"
            name="membership_duration_id"
            value={formData.membership_duration_id}
            option={
              formData.package_id
                ? fetchMembershipDurationByPackageId?.membershipDuration?.map(
                    (item: MembershipDurationsProps) => (
                      <option
                        key={item.id.toString()}
                        value={item.id.toString()}
                      >
                        {item.duration_type}
                      </option>
                    )
                  )
                : []
            }
            onChange={handleChange}
          />
          {error.membership_duration_id && (
            <Error>{error.membership_duration_id}</Error>
          )}
          {isSerachUser ? (
            <></>
          ) : (
            <div className="relative">
              <InputForm
                label="User Id"
                type="text"
                id="user_id"
                name="user_id"
                value={formData.user_id}
                onChange={handleChange}
                autoComplete="off"
                readOnly={initialData?.user_id ?true :false}
              />
              {error.user_id && <Error>{error.user_id}</Error>}
              {/* {filteredUsers.length > 0 && (
                <ul className="absolute bg-white border w-full max-h-40 overflow-auto z-10">
                  {filteredUsers.map((user: CommercialUserProps) => (
                    <li
                      key={user.id}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        handleChange({
                          target: {
                            name: "user_id",
                            value: user.id,
                            type: "text",
                          },
                        } as React.ChangeEvent<HTMLInputElement>);
                      }}
                    >
                      {user.email} - {user.mobile_no} - {user.user_identifier}
                    </li>
                  ))}
                </ul>
              )} */}
            </div>
          )}
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};

const mapStateToProps = (state: any) => ({
  fetchPackages: state.packages?.fetchPackagesState,
  fetchMembershipDurationByPackageId:
    state.membershipDuration?.fetchmembershipDurationState,
  fetchCommercialUsers: state.commercialUser.commercialUserState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackages: () => dispatch(fetchPackages()),
  onFetchMembershipDuration: (package_id: string) =>
    dispatch(fetchMembershipDurationByPackageId(package_id)),
  onFetchCommercialUsers: (limit:number, offset:number) => dispatch(fetchCommercialUsers(limit, offset)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MembershipPlanForm);
